import withErrorHandler from '../../../modules/error/ErrorHandlerWrapper';
import CompleteProfileBlock, { CompleteProfileBlockProps } from './CompleteProfileBlock';
import withInteractor from './CompleteProfileBlock.interactor';
import withPresenter from './CompleteProfileBlock.presenter';

export type { CompleteProfileBlockProps };
export default withInteractor(withPresenter(withErrorHandler(CompleteProfileBlock)));
